import { ReactElement, useEffect } from "react";
import { createRoot } from "react-dom/client";

export const useMapControl = (
  map: google.maps.Map | null,
  controlPosition: google.maps.ControlPosition | null,
  children: ReactElement
) => {
  useEffect(() => {
    if (map && controlPosition) {
      let container = document.querySelector<HTMLDivElement>("#google-map-control");
      if (!container) {
        container = document.createElement("div");
        container.id = "google-map-control";
        document.body.appendChild(container);
      }

      const root = createRoot(container);

      root.render(
        <div
          ref={(element) => {
            if (element) {
              map.controls[controlPosition].push(element);
            }
          }}
        >
          {children}
        </div>
      );
    }

    return () => {
      if (map && controlPosition) {
        map.controls[controlPosition].clear();
      }
    };
  }, [map, controlPosition, children]);
};
